// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container___6bNES{padding-top:24px;line-height:var(--made-font-body-line-height);font-weight:var(--made-font-weight-default)}\n", "",{"version":3,"sources":["webpack://./src/components/RulesHeader/ScheduledDeploymentModal/content/Delete.css"],"names":[],"mappings":"AAAA,mBACI,gBAAA,CACA,6CAAA,CACA,2CAAA","sourcesContent":[".container {\n    padding-top: 24px;\n    line-height: var(--made-font-body-line-height);\n    font-weight: var(--made-font-weight-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container___6bNES"
};
export default ___CSS_LOADER_EXPORT___;
